import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import { REACT_APP_BASENAME, REACT_APP_ENV } from './common/constants'
import App from './routes/App'
import ControlsDigitalCertificate from './routes/ControlsDigitalCertificate'
import ControlsEdit from './routes/ControlsEdit'
import ControlsEditBodyCondition from './routes/ControlsEditBodyCondition'
import ControlsEditCar from './routes/ControlsEditCar'
import ControlsEditEquipment from './routes/ControlsEditEquipment'
import ControlsEditGuarantee from './routes/ControlsEditGuaratee'
import ControlsEditInteriorCondition from './routes/ControlsEditInteriorCondition'
import ControlsEditReviewHistory from './routes/ControlsEditReviewHistory'
import ControlsEditTodo from './routes/ControlsEditTodo'
import ControlsEditTyres from './routes/ControlsEditTyres'
import ControlsEditUsedCarControl from './routes/ControlsEditUsedCarControl'
import ControlsNew from './routes/ControlsNew'
import ControlsNewCar from './routes/ControlsNewCar'
import ControlsNewType from './routes/ControlsNewType'
import ControlsPDF from './routes/ControlsPDF'
import ControlsSummary from './routes/ControlsSummary'
import NoMatch from './routes/NoMatch'
import { checkEnvironment } from './utils/helpers'
import PrivateRoutes from './utils/PrivateRoute'

const usedCarsRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <NoMatch /> },
      { path: 'details.html', element: <ControlsDigitalCertificate index /> },
      {
        path: 'wyszukiwarkaszczegoly/:mark/:model/:year/:carId',
        element: <ControlsDigitalCertificate index />,
      },
      {
        path: 'uzywanedealerszczegoly/:dealer/:mark/:model/:year/:carId',
        element: <ControlsDigitalCertificate index />,
      },
      {
        path: 'certificate/:id',
        element: <ControlsDigitalCertificate />,
      },
      {
        path: 'pdf/:id',
        element: <ControlsPDF />,
      },
      {
        path: '*',
        element: <NoMatch />,
      },
    ],
  },
]

const carExportRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/controls/new/car" replace /> },
      {
        element: <PrivateRoutes />,
        children: [
          {
            path: 'controls',
            element: <ControlsNew />,
            children: [
              {
                index: true,
                element: <Navigate to="/controls/new/car" replace />,
              },
              {
                path: 'new/car',
                element: <ControlsNewCar />,
              },
              {
                path: 'new/type',
                element: <ControlsNewType />,
              },
              {
                path: ':id/edit',
                element: <ControlsEdit />,
                children: [
                  { index: true, element: <ControlsEditCar /> },
                  {
                    path: 'carBasicData',
                    element: <ControlsEditCar />,
                  },
                  {
                    path: 'guarantee',
                    element: <ControlsEditGuarantee />,
                  },
                  {
                    path: 'reviewHistory',
                    element: <ControlsEditReviewHistory />,
                  },
                  {
                    path: 'bodyCondition',
                    element: <ControlsEditBodyCondition />,
                  },
                  {
                    path: 'interiorCondition',
                    element: <ControlsEditInteriorCondition />,
                  },
                  { path: 'equipment', element: <ControlsEditEquipment /> },
                  { path: 'tyres', element: <ControlsEditTyres /> },
                  {
                    path: 'technicalCondition',
                    element: <ControlsEditUsedCarControl />,
                  },
                  { path: 'todo', element: <ControlsEditTodo /> },
                ],
              },
              {
                path: ':id/summary',
                element: <ControlsSummary />,
              },
              {
                path: ':id/digital',
                element: <ControlsDigitalCertificate />,
              },
              {
                path: ':id/pdf',
                element: <ControlsPDF />,
              },
              {
                path: '*',
                element: <NoMatch />,
              },
            ],
          },
        ],
      },
      {
        path: 'pdf/:id',
        element: <ControlsPDF />,
      },
    ],
  },
]

const routes = checkEnvironment(REACT_APP_ENV, 'usedcars')
  ? usedCarsRoutes
  : carExportRoutes

const opts = {
  basename: REACT_APP_BASENAME,
}

export default createBrowserRouter(routes, opts)
